import React, { useState, useEffect, useContext } from 'react';
import { Spinner, Stack, Text, Panel, PanelType } from 'office-ui-fabric-react';
import "./DetailContainer/DetailContainer.scss";
import DetailContainer from './DetailContainer/DetailContainer';
import { ApolloProvider } from "react-apollo";
import { Query } from "react-apollo";
import { queryGetEntryWithJWT } from "./../../queries/queryRecordings";
import { MyContext } from '../../context';

const DetailContainerStandalone = (props) => {
    const [jwtToken, setJwtToken] = useState(null);
    const context = useContext(MyContext);

    useEffect(() => {
        const urlParts = window.location.pathname.split('/');
        const token = urlParts[urlParts.length - 1];
        setJwtToken(token);
    }, []);

    const renderData = (jwtToken, callStartMs) => (
        <div>
            <Query
                query={queryGetEntryWithJWT}
                variables={{ jwtToken, callStartMs }} pollInterval={120000} fetchPolicy="network-only">
                {({ loading, error, data }) => {

                    if (loading) return (
                        <Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                    );

                    if (error) {
                        return <div></div>;
                    }

                    if (data.getEntryWithJWT == null) return <div className="centered-text">{context.getTranslation("common", "recordingNotAvailable")}</div>;

                    return (
                        <DetailContainer
                            data={data.getEntryWithJWT}
                            theme={props.theme}
                            wia="57"
                            isShared={true}
                        />
                    );
                }}
            </Query>
        </div>
    );

    if (jwtToken != null) {
        return (
            <ApolloProvider client={props.apol}>
                <Panel isOpen={true} type={PanelType.smallFluid} onRenderNavigation={() => <div style={{ height: '48px' }}></div>}>
                    {renderData(jwtToken, null)}
                </Panel>
            </ApolloProvider>
        );
    } else {
        return "";
    }
};

export default DetailContainerStandalone;
